// Importaciones de librerías externas
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// Importaciones de componentes
import { ShopMainSection, WhyChooseAlma } from "../components/Shop";

// Importaciones de hooks y utilidades
import useWindowSize from "../utils/useWindowSize";
import useCategories from "../hooks/categories/useCategories";
import useProducts from "../hooks/products/useProducts";

// Importaciones de estilos
import "../assets/css/Shop/index.css";

const ShopPage = () => {
    // Estados relacionados con categorías y productos
    const { subCategories, loadingSubCat, fetchSubCategories } = useCategories();
    const { products, loading, setLoading, setProducts, fetchProducts, getProductsShop } = useProducts();

    // Estados relacionados con filtros y búsqueda
    const [searchParams] = useSearchParams();
    const categoryUid = searchParams.get("uid");
    const categoryName = searchParams.get("categoryName");
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([categoryUid]);
    const [filters, setFilters] = useState({ categories: [categoryUid] });
    const [viewFilters, setViewFilters] = useState(false);
    const [value, setValue] = useState([120, 1037]);

    // Estados relacionados con la interfaz y carga
    const [loadingText, setLoadingText] = useState("Cargar más productos");
    const [loadingMore, setLoadingMore] = useState(false);
    const [animationClass, setAnimationClass] = useState("");
    const [firstLoad, setFirstLoad] = useState(true);
    const { width } = useWindowSize();
    const [page, setPage] = useState(1);
    const initialUrl = window.location.href;

    // Manejo de eventos
    const handleChange = (event, newValue) => {
        setValue(newValue);
        setFilters((prevFilters) => ({ ...prevFilters, priceRange: newValue }));
    };

    const handleCheckboxChange = (id) => {
        setSelectedCheckboxes((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const handleOpen = () => {
        setViewFilters(true);
        setAnimationClass("active animate__animated animate__slideInRight");
    };

    const handleClose = () => {
        setAnimationClass("active animate__animated animate__slideOutRight");
        setTimeout(() => {
            setViewFilters(false);
            setAnimationClass("");
        }, 800);
    };

    const applyFilters = () => {
        setLoading(true);
        handleClose();
        setTimeout(() => {
            setPage(1);
            setLoadingText("Cargar más productos");
            fetchProducts({ page: 1, limit: 9, filters });
        }, 1000);
    };

    const loadingMoreProduct = async () => {
        let pageNow = page + 1;
        setLoadingMore(true);
        setLoadingText("Cargando .");
        setPage(pageNow);

        let dots = "";
        const interval = setInterval(() => {
            dots = dots.length < 3 ? dots + "." : "";
            setLoadingText(`Cargando .${dots}`);
        }, 500);

        let newProducts = await getProductsShop({ page: pageNow, limit: 9, filters });
        
        setTimeout(() => {
            if (newProducts?.products?.length > 0) {
                clearInterval(interval);
                setLoadingMore(false);
                setLoadingText("Cargar más productos");
                
                setProducts((prevProducts) => ({
                    ...prevProducts,
                    products: [...prevProducts.products, ...newProducts.products],
                }));
            } else {
                clearInterval(interval);
                setLoadingMore(false);
                setLoadingText("No hay más productos para cargar");
            }
        }, 1000);
    };

    // Efectos
    useEffect(() => {
        setTimeout(() => {
            fetchProducts({ page: 1, limit: 9, filters });
            fetchSubCategories({ page: 1, limit: 10, type: "subcategory", filters: { categoryId: categoryUid } });
        }, 1000);
    }, []);

    useEffect(() => {
        if (!loading && products?.products?.length > 0 && firstLoad) {
            setValue([products.priceRange.minPrice, products.priceRange.maxPrice]);
            setFirstLoad(false);
        }
    }, [products]);

    useEffect(() => {
        if (!firstLoad) {
            setFilters((prevFilters) => ({ ...prevFilters, categories: selectedCheckboxes }));
        }
    }, [selectedCheckboxes]);

    // Renderizado del componente
    return (
        <div className="w-100 page-shop">
            {/* Banner de la tienda */}
            <ShopBanner categoryName={categoryName} products={products} loading={loading} handleOpen={handleOpen} />

            {/* Sección principal de la tienda */}
            <ShopMainSection
                subCategories={subCategories}
                loadingSubCat={loadingSubCat}
                selectedCheckboxes={selectedCheckboxes}
                handleCheckboxChange={handleCheckboxChange}
                filters={filters}
                setFilters={setFilters}
                value={value}
                handleChange={handleChange}
                products={products}
                loading={loading}
                loadingMoreProduct={loadingMoreProduct}
                loadingMore={loadingMore}
                loadingText={loadingText}
                viewFilters={viewFilters}
                animationClass={animationClass}
                handleClose={handleClose}
                applyFilters={applyFilters}
                width={width}
                initialUrl={initialUrl}
            />

            {/* Sección "¿Por qué elegir a Alma?" */}
            <WhyChooseAlma />
        </div>
    );
};

// Componentes auxiliares
const ShopBanner = ({ categoryName, products, loading, handleOpen }) => (
    <div className="section-banner-shop">
        <div className="container">
            <div className="d-flex">
                <div className="w-100">
                    <h1>{categoryName}</h1>
                    {!loading && products && products.length > 0 ? (
                        <p className="fs-11 d-md-none">
                            {products?.totalProducts ? products?.totalProducts : ""} resultados
                        </p>
                    ) : (
                        <></>
                    )}
                </div>
                <div className="d-md-none d-flex align-items-start justify-content-end">
                    <button className="btn btn-gray-primary" type="button" onClick={handleOpen}>
                        Filtros
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export default ShopPage;